var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('rect',{staticClass:"chartColoredPeriod",attrs:{"width":_vm.width,"height":_vm.chartColoredPeriodHeight,"x":_vm.x,"y":_vm.strokeWidth,"fill":_vm.fill,"stroke":_vm.stroke},on:{"mouseenter":_vm.onMouseEnter,"mouseleave":_vm.onMouseLeave}})
}
var staticRenderFns = []

export { render, staticRenderFns }